// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectQuote4Message } from '@shared/utils/DirectMessages/DirectQuote4Message';
import { Quote1MessageProcessor } from './Quote1MessageProcessor';
export class Quote4MessageProcessor extends MessageProcessorBase {
    constructor(decoder, advancedTableContainer) {
        super();
        this.decoder = decoder;
        this.l1Processor = new Quote1MessageProcessor(decoder, advancedTableContainer);
    }
    decode(fieldSet) {
        const decoder = this.decoder;
        const symDecodeMap = decoder.InstrumentDecodeMap;
        const l1Processor = this.l1Processor;
        const message = new DirectQuote4Message();
        // на сервере сначала символ=GOOG115CALLDec8, потом андерлайер=GOOG
        // только они называют их наоборот
        message.Symbol = fieldSet.GetValue(FieldsFactory.FIELD_UNDERLIER);
        const tickId = fieldSet.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
        message.Underlier = symDecodeMap[tickId] || '';
        const routeId = fieldSet.GetValue(FieldsFactory.FIELD_ROUTE_ID);
        message.Route = routeId; // decoder.GetRouteById(routeId)
        message.Bid = fieldSet.GetValue(FieldsFactory.FIELD_BID);
        const fieldBidVolume = fieldSet.GetValue(FieldsFactory.FIELD_BID_VOLUME);
        message.BidSize = fieldBidVolume === null ? fieldSet.GetValue(FieldsFactory.FIELD_BID_SIZE) : fieldBidVolume;
        message.Ask = fieldSet.GetValue(FieldsFactory.FIELD_ASK);
        const fieldAskVolume = fieldSet.GetValue(FieldsFactory.FIELD_ASK_VOLUME);
        message.AskSize = fieldAskVolume === null ? fieldSet.GetValue(FieldsFactory.FIELD_ASK_SIZE) : fieldAskVolume;
        message.Open = fieldSet.GetValue(FieldsFactory.FIELD_OPEN);
        message.High = fieldSet.GetValue(FieldsFactory.FIELD_HIGH);
        message.Low = fieldSet.GetValue(FieldsFactory.FIELD_LOW);
        message.PrevClose = fieldSet.GetValue(FieldsFactory.FIELD_PRE_CLOSE);
        message.Volume = fieldSet.GetValue(FieldsFactory.FIELD_VOLUME_TOTAL);
        message.Last = fieldSet.GetValue(FieldsFactory.FIELD_LAST_PRICE);
        message.LastSize = fieldSet.GetValue(FieldsFactory.FIELD_LAST_SIZE);
        message.OpenInterest = fieldSet.GetValue(FieldsFactory.FIELD_OPEN_INTEREST);
        message.cTime = fieldSet.GetValue(FieldsFactory.FIELD_DATE);
        message.InstrumentTradableID = fieldSet.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
        // для сгенерированных инструментов
        const level1 = l1Processor.decode(fieldSet);
        return [message, level1[0], level1[1]];
    }
}
